import { Button } from '@mui/material';
import BarcodeScanner5 from 'app/components/Barcode/Barcode';
import { RtlTextField } from 'app/components/RTLTextField';
import Api, { apiPaths } from 'app/services/api';
import { enqueueSnackbar } from 'notistack';
import React, { useState } from 'react';
import { translate } from 'translate';

const AssignCard = () => {
  const [showSerialReader, setshowSerialReader] = React.useState(false);
  const path = window.location.pathname.split('/');
  const store_uuid = path[path.length - 1];
  const [serial, setSerial] = useState();

  const handleScan = async (e) => {
    await Api.post(apiPaths.STORES + '/assign/card', {
      warranty_number: e,
      store_uuid,
    })
      .then((res) => {
        enqueueSnackbar(translate('Warranty assigned successfully'), { variant: 'success' });
      })
      .catch((e) => {
        enqueueSnackbar(translate(e || 'Something went wrong'), { variant: 'error' });
      });
  };

  const handleSubmit = async (e) => {
    await handleScan(serial);
    setSerial('');
  };

  return (
    <div>
      <div className="w-full flex flex-col gap-8 items-center justify-center h-64">
        برای اختصاص کارت را اسکن کنید یا شماره سریال کارت را وارد کنید
        <Button className="" variant="contained" onClick={() => setshowSerialReader(true)}>
          {translate('Scan')}
        </Button>
      </div>
      {showSerialReader && (
        <BarcodeScanner5
          onDetected={(e) => {
            handleScan(e);
            setshowSerialReader(false);
          }}
          onClose={() => {
            setshowSerialReader(false);
          }}
          open={showSerialReader}
          qrPattern={/^\d{8,9}$/}
        />
      )}
      <div className="w-full flex justify-center items-center gap-4">
        {translate('Serial Number')}
        <RtlTextField value={serial} onChange={(e) => setSerial(e.target.value)} />
        <Button className="" variant="contained" onClick={handleSubmit}>
          {translate('Submit')}
        </Button>
      </div>
    </div>
  );
};

export default AssignCard;
//
